import Marquee from "react-fast-marquee";
import { PRESS } from "@/data/content";

const PRESS_STYLE = {
  "VOGUE": "font-display text-3xl font-medium uppercase tracking-[0.35em]",
  "ELLE": "font-display text-3xl font-bold uppercase tracking-[0.3em]",
  "Harper's BAZAAR": "font-display text-2xl tracking-wide",
  "marie claire": "font-display text-3xl italic lowercase tracking-tight",
  "COSMOPOLITAN": "font-sans text-2xl font-extrabold uppercase tracking-tight",
  "BEAUTY CREW": "font-sans text-xl font-semibold uppercase tracking-[0.18em]",
};

export const PressMarquee = ({ label = "As Featured In" }) => (
  <div className="overflow-hidden border-y border-[#F2E8E6] bg-[#FFFCFA] py-8" data-testid="press-marquee">
    <p className="mb-6 text-center text-[0.65rem] uppercase tracking-[0.3em] text-[#232222]">{label}</p>
    <Marquee gradient gradientColor="#FFFCFA" gradientWidth={120} speed={30}>
      {PRESS.concat(PRESS).map((p, i) => (
        <span key={i} className={`mx-12 text-[#2C2B2C] ${PRESS_STYLE[p] || "font-display text-2xl"}`}>
          {p}
        </span>
      ))}
    </Marquee>
  </div>
);

export const EditorialMarquee = () => {
  const items = ["FDA Cleared", "Dermatologist Approved", "53 mW/cm² Irradiance", "114 Medical-Grade LEDs", "UV-Free", "Made for Real Women"];
  return (
    <div className="overflow-hidden border-y border-[#F2E8E6] bg-white py-6" data-testid="editorial-marquee">
      <Marquee gradient gradientColor="#FFFCFA" gradientWidth={100} speed={38}>
        {items.concat(items).map((t, i) => (
          <span key={i} className="mx-8 inline-flex items-center font-display text-2xl font-light italic text-[#8A7F86]">
            {t}<span className="ml-8 not-italic text-[#FBC4A8]">✨</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
